import { render, staticRenderFns } from "./asignar-numeros.vue?vue&type=template&id=735ac940&"
import script from "./asignar-numeros.vue?vue&type=script&lang=js&"
export * from "./asignar-numeros.vue?vue&type=script&lang=js&"
import style0 from "./asignar-numeros.vue?vue&type=style&index=0&id=735ac940&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports